import { useEffect, useState } from 'react'
import type { AccordionPlusProps } from '../AccordionPlus'
import type { AccordionPlusIconProps } from '../types/AccordionPlusBaseProps'

export const useTrackIcon = (props: Pick<AccordionPlusProps, 'open'>) => {
    const isSingleIcon = 'iconName' in props
    const {
        iconName = '',
        openIconName = '',
        closedIconName = '',
        open = false,
    } = props as AccordionPlusProps & AccordionPlusIconProps

    const [icon, setIcon] = useState({
        class: isSingleIcon ? 'icon' : open ? 'opened-icon' : 'closed-icon',
        name: isSingleIcon ? iconName : open ? openIconName : closedIconName,
    })

    useEffect(() => {
        if (isSingleIcon) return
        setIcon({
            class: open ? 'opened-icon' : 'closed-icon',
            name: open ? openIconName : closedIconName,
        })
    }, [open, isSingleIcon, openIconName, closedIconName])

    return icon
}
